

import React, {useState} from 'react';
import PropTypes from 'prop-types';
import html2canvas from 'html2canvas';
import {getText} from 'helpers/text-helper';
import {getGameResults} from 'helpers/game-helper';
import GameProgress from 'components/ui/game-progress/game-progress';
import Result from 'components/ui/result/result';
import Discussion from 'components/ui/discussion/discussion';
import Button from 'components/ui/button/button';
import './game-results.scss';

const GameResults = ({languageId, deviceInfo, gameData, groupsData, goToPage}) => {
	/* Get results */
	const resultsData = getGameResults(gameData, groupsData);
	
	/* Result page index */
	const [resultIndex, setResultIndex] = useState(0);

	/* Get data for current result */
	const currentResultData = resultsData[resultIndex];

	/**
	 * Go to prev result page / game status page
	 */
	const handleGoToPage = (direction) => {
		if (resultIndex < 0) return;

		if (direction === 'prev') {
			if (resultIndex === 0) {
				goToPage('game-results-intro');
			} else {
				setResultIndex(resultIndex - 1);
			}
		} else if (direction === 'next') {
			if (resultIndex + 1 < resultsData.length) {
				setResultIndex(resultIndex + 1);
			} else {
				goToPage('game-results-outro');
			}
		}
	};


	const handleSaveResult = () => {
		const resultElement = document.getElementById('result-' + resultIndex);
		html2canvas(resultElement).then((canvas) => {
			const imgData = canvas.toDataURL('image/png');
			const link = document.createElement('a');
			link.href = imgData;
			link.download = 'diipta-result-' + (resultIndex + 1) + '.png';
			link.click();
		});
	};

	

	return (
		<div className={'GameResults ' + deviceInfo.orientation}>

			{/* Home btn */}
			<div className="GameResults-homeBtn" onClick={() => {goToPage('settings');}} />
			
			{/* Content */}
			{currentResultData && <div className="GameResults-content">
				{/* Game progress */}
				{currentResultData.showProgress && <GameProgress 
					languageId={languageId}
					progressStepId={'results'}
					deviceInfo={deviceInfo}
				/>}
				{(currentResultData.type === 'result' && currentResultData.result) && 
					<div id={'result-' + resultIndex} className="GameResults-result">
						<Result 
							resultId={currentResultData.id}
							languageId={languageId}
							deviceInfo={deviceInfo} 
							resultData={currentResultData}
						/>
					</div>}
				{(currentResultData.type === 'discussion') && 
					<div className="GameResults-discussion">
						<Discussion 
							languageId={languageId}
							deviceInfo={deviceInfo} 
							resultData={currentResultData}
						/>
					</div>}
			</div>}

			<div className="GameResults-backBtn">
				<Button 
					classes={['orange', 'fullHeight']}
					text={getText('general_back', languageId)}
					onClick={() => {handleGoToPage('prev');}}
				/>
			</div>
			<div className="GameResults-saveBtn">
				<Button 
					classes={['orange', 'fullHeight']}
					text={getText('pages_saveResults', languageId)}
					onClick={() => {handleSaveResult();}}
				/>
			</div>

			<div className="GameResults-nextBtn">
				<Button 
					classes={['orange', 'next', 'fullHeight']}
					text={getText('general_next', languageId)}
					onClick={() => {handleGoToPage('next');}}
				/>
			</div>
		
		</div>
	);
};

GameResults.propTypes = {
	languageId: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	gameData: PropTypes.object.isRequired,
	groupsData: PropTypes.array.isRequired,
	goToPage: PropTypes.func.isRequired
};

export default GameResults;